// extracted by mini-css-extract-plugin
export default {"modalWrapper":"OrderUpload_modalWrapper__6Jr1+","modalWrapper2":"OrderUpload_modalWrapper2__HkJoP","loader":"OrderUpload_loader__91odd","l3":"OrderUpload_l3__uG-4L"};